export default __webpack_public_path__ + "5432bfc7bc6bc00f9f6ad2d0da0794b9.png";